import { __exports as e } from "./contact-channels204.js";
import { __require as s } from "./contact-channels205.js";
import { __require as m } from "./contact-channels206.js";
var i;
function D() {
  if (i) return e;
  i = 1;
  var u = e && e.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.default = _;
  var a = u(s()), o = m(), n = /<(![a-zA-Z\s]+)>/;
  function _(r) {
    if (typeof r != "string")
      throw new TypeError("First argument must be a string");
    if (!r)
      return [];
    var t = r.match(n), f = t ? t[1] : void 0;
    return (0, o.formatDOM)((0, a.default)(r), null, f);
  }
  return e;
}
export {
  D as __require
};
//# sourceMappingURL=contact-channels158.js.map
